var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5690_12453",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5690_12453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.7049L6.29508 20.4098C5.93443 20.7705 5.47541 20.9508 4.91803 20.9508C4.36066 20.9508 3.90164 20.7705 3.54098 20.4098C3.18033 20.0492 3 19.5902 3 19.0328C3 18.4754 3.18033 18.0164 3.54098 17.6557L9.2459 11.9508L3.54098 6.29508C3.18033 5.93443 3 5.47541 3 4.91803C3 4.36066 3.18033 3.90164 3.54098 3.54098C3.90164 3.18033 4.36066 3 4.91803 3C5.47541 3 5.93443 3.18033 6.29508 3.54098L12 9.2459L17.6557 3.54098C18.0164 3.18033 18.4754 3 19.0328 3C19.5902 3 20.0492 3.18033 20.4098 3.54098C20.8033 3.93443 21 4.40164 21 4.94262C21 5.48361 20.8033 5.93443 20.4098 6.29508L14.7049 11.9508L20.4098 17.6557C20.7705 18.0164 20.9508 18.4754 20.9508 19.0328C20.9508 19.5902 20.7705 20.0492 20.4098 20.4098C20.0164 20.8033 19.5492 21 19.0082 21C18.4672 21 18.0164 20.8033 17.6557 20.4098L12 14.7049Z",
    fill: "#41454B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseQr);
export default __webpack_public_path__ + "static/media/close_qr.92e72d3937b6f251f66186bb74f9fe3b.svg";
export { ForwardRef as ReactComponent };